(() => {
    document.addEventListener("DOMContentLoaded", ev => {
		const contentsWithStyles = document.querySelectorAll('.seo-content.with-styles, .seo-content-context.with-styles');
		contentsWithStyles.forEach(c => {
			let txt = c.dataset.text;
			if (c.classList.contains('with-bold') || txt.includes('!1!')) {
				txt = txt.replace(
					/!1!([\s\S]*?)!2!/g,
					"<b>$1</b>"
				);
			}

			if (c.classList.contains('with-italic') || txt.includes('#1#')) {
				txt = txt.replace(
					/#1#([\s\S]*?)#2#/g,
					"<i>$1</i>"
				);
			}

			if (c.classList.contains('with-landingPgLink')) {
				let i=0;				
				txt = txt.replace(/\[([^\]]+)\]/g, (_, text) => {
					const href = c.dataset[`landing-${i++}`] ?? "#";
					return `<a class="seo-paragraph-internal-inlink" href="${href}">${text}</a>`;
				});

			}
			c.innerHTML = txt;
		})
	});
})()